import { render, staticRenderFns } from "./contact-picker.vue?vue&type=template&id=10732456&scoped=true&"
import script from "./contact-picker.vue?vue&type=script&lang=js&"
export * from "./contact-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10732456",
  null
  
)

export default component.exports